import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AnnuityItemsViewModel, AnnuityViewModel } from '../../../models/annuity-view.model';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { AMPSubscriptionDetailsItemViewModel, AMPubscriptionModel, GetAMPSubscription, IAMPAnnuityItemsViewModel, IAMPCustomerDetailsViewModel, IAMPOrdersByCustomerResponse, IAMPModifySubscriptionResponse, IAMPAssociationResponseLineItem, IAMPAssociationResponse, IpreviewRenewal } from '../../../models/amp.model';
import { AdobeService } from '../../../services/adobe.service';
import { ManageService } from '../../../services/manage.service';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from '../../../services/auth.service';
import { CurrentUserModel } from '../../../models/account-ledger.model';
import { DatePipe, DecimalPipe, CurrencyPipe } from '@angular/common';
import { FileService } from '../../../services/file.service';
import { NgProgressService } from '../../../services/ngProgress.service';


@Component({
  selector: 'app-manage-amp-customer',
  templateUrl: './manage-amp-customer.component.html',
  styleUrls: ['./manage-amp-customer.component.css'],
  providers: [DatePipe, DecimalPipe, CurrencyPipe]
})
export class ManageAMPCustomerComponent implements OnInit, OnDestroy {

  private tenantId: string;
  private orderHistoryPage = 1;
  public title: string;
  public ampSubs: GetAMPSubscription[] = [];
  public eligibleOffers: any[] = [];
  public ampSubsTableDataSource = new MatTableDataSource(this.ampSubs);
  public pendingTransactions: any[] = []
  public pendingTransactionsTableDataSource = new MatTableDataSource(this.pendingTransactions);

  public orderHistory: IAMPOrdersByCustomerResponse[] = []
  public orderHistoryTableDataSource = new MatTableDataSource(this.orderHistory);
  public orderHistoryDateFromText: string = '';

  //public renewalPreview: IAMPAnnuityItemsViewModel[]=[];

  public renewalPreview: IpreviewRenewal[]=[];
  //public previewRenewalSubscription :IpreviewRenewal;
  public previewRenewalSubscription :AMPubscriptionModel;
  //previewRenewalSubs: IpreviewRenewal[];

  previewRenewalSubs: AMPubscriptionModel[];

  public AMPDetailsItemViewModel: AMPSubscriptionDetailsItemViewModel;
  public details: IAMPCustomerDetailsViewModel;

  public activeTotal = '0';
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public isStaffAccount = false;
  public showCustomerDetail = false;

  public annuity: AnnuityViewModel;
  public currentUserModel: CurrentUserModel;
  public isAMPItemLoading = true;
  public isAMPTenantDetailLoading = true;
  public isEligibleOffersLoading = true;
  public pendingTransactionLoading = true;
  public orderHistoryLoading = false;
  public orderHistoryTabOpened = false;
  public displayedColumns = ['desc', 'qty', 'usedQty', 'autoRenew', 'scheduledRenewalQty', 'status', 'manageBtn'];
  public pendingTransactionDisplayedColumns = ['referenceId', 'creationDate', 'expiryDate', 'quantity', 'productName']
  public orderHistoryDisplayedColumns = ['orderDate','customerReference', 'orderType', 'stockCode', 'stockDescription', 'qty']
  public disableBuyButton = false;
  public loadingPreview = false;

  constructor(
    private adobeService: AdobeService,
    private manageService: ManageService,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private currencyPipe: CurrencyPipe,
    private router: Router,
    private datePipe: DatePipe,
    private _decimalPipe: DecimalPipe,
    public authService: AuthService,
    private fileService: FileService,
    private ngProgress: NgProgressService
  ) {
  }

  async ngAfterViewInit() {
    await this.commonService.waitForElm('#levelOne');
    this.activatedRoute.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      setTimeout(() => {
        if (
          !$('#upgradeAMPSubscription').length
          && !$('#addAMPProduct').length
          && !$('#manageAMPSubscription').length
          && !$('#confirmAMPProduct').length
          && !$('#view-high-growth-offers').length
        ) {
          $('#levelOne').animate({ scrollLeft: 250 }, 400);
        }
      }, 100);
    });
  }

  ngOnInit() {
    this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (user: CurrentUserModel) => {
          this.isStaffAccount = user.isStaffAccount;
        }
      );

    this.activatedRoute.paramMap
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(param => {
        this.tenantId = param.get('tenantId');

        if (this.tenantId) {

          // fetching data for this blade
          this.fetchAMPTenantDetailView();              
          this.fetchAMPItemsView();

          // conditional fetching data for pending transations
          this.manageService.currentAnnuityList
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((annuities) => {
              this.annuity = annuities?.find(a => a.annuityId === this.tenantId)
              if (this.annuity?.isAMPPendingTransaction) this.fetchPendingTransactions();
            });

          // setting up blade if it's for quote customer or normal customer
          this.adobeService.getCurrentAMPCustomersForQuotes
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((quoteCustomers) => {
              if (quoteCustomers != null && !quoteCustomers.find(q => q.tenantId == this.tenantId)) {
                this.showCustomerDetail = true;
              } else {
                this.title = 'INDICATIVE PRICING';
              }     
            });
        }
      });


    
    // setting up refresh listeners for other places' trigger
    this.adobeService.refetchAMPTenantDetailView$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => this.fetchAMPTenantDetailView());
    this.adobeService.refetchAMPItemsView$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => this.fetchAMPItemsView());
  }

  private appplyOrderHistoryFilter() {
    this.orderHistoryTableDataSource.filterPredicate = (data: IAMPOrdersByCustomerResponse, filter: string) => {
      const filterValue = filter.toLowerCase();
      return this.datePipe.transform(data.creationDate, 'dd/MM/yyyy h:mm a').toLowerCase().includes(filterValue) ||
            data.orderType?.toLowerCase().includes(filterValue) ||
            data.offerId?.toLowerCase().includes(filterValue) ||
            data.stockDescription?.toLowerCase().includes(filterValue) ||
            data.quantity?.toString().toLowerCase().includes(filterValue) ||
            data.externalReferenceId?.toString().toLowerCase().includes(filterValue);
    }
  }

  private fetchPendingTransactions(): void {
    this.adobeService
      .getAMPLicensesPendingPartnerOrders(this.tenantId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: any) => {
          this.pendingTransactions = res?.unpaidLicenses
          this.pendingTransactionsTableDataSource = new MatTableDataSource(res?.unpaidLicenses);
        },
        error: (error: string) => this.commonService.implementToast(error, "Error"),
        complete: () => this.pendingTransactionLoading = false
      })
  }

  private fetchAMPPreviewRenewal(): void {
    this.isEligibleOffersLoading = true;
    this.adobeService.AMPPreviewRenewal(this.tenantId, this.details?.customer?.three_year_commitment_start_date)
    .pipe(
      finalize(() => {
        this.isEligibleOffersLoading = false
      }),
      takeUntil(this.ngUnsubscribe)
    )
      .subscribe((res: any) => {        
        if(res.responseMessage){
          this.renewalPreview = [res.responseMessage, res.status];
        }
        else{ this.renewalPreview = [...res.lineItems];}       
        if (res?.eligibleOffers) this.renewalPreview = [...this.renewalPreview,...res.eligibleOffers];         
        if (res?.eligibleOffers) this.eligibleOffers = [ ...res?.eligibleOffers ];
        this.adobeService.monitorcurrentEligibleOffers(this.eligibleOffers);        
      });
  }

  private fetchAMPTenantDetailView(): void {
    this.isAMPTenantDetailLoading = true;
    this.adobeService
      .getAMPCustomerDetails(this.tenantId)
      .pipe(
        finalize(() => {
          this.isAMPTenantDetailLoading = false
        }),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe({
        next: (res: IAMPCustomerDetailsViewModel) => {
          // if (!this.details) {
          //   if (res?.customer?.three_year_commitment_status == 'REQUESTED') {
          //     this.dialog.open(SimpleMsgPopupComponent, {
          //       width: '400px',
          //       data: {
          //         title: 'Warning',
          //         msg: 'Customer must accept the 3 Year Commitment invitation to qualify for 3 Year Commitment pricing.',
          //         buttonName: 'Ok'
          //       }
          //     });
          //   }
          // }

          this.details = res;
          this.fetchAMPPreviewRenewal();
          
          if (this.annuity) this.title = this.details?.customer?.company_name;

          const daysDiff = Math.round((new Date(this.details?.customer?.coterm_date).getTime() - this.commonService.getPDTDate().getTime()) / (1000 * 3600 * 24));
          if (daysDiff > 0 && daysDiff <= 2) this.disableBuyButton = true;

          this.adobeService.monitorAMPCustomerDetailsChange(this.details);
        },
        error: (error: string) => this.commonService.implementToast(error, "Error")
      })
  }

  private fetchAMPItemsView(): void {
    this.isAMPItemLoading = true;
    this.adobeService
      .getAMPItemsView(
        this.tenantId,
        this.showAnniversaryDate(this.annuity) ? this.annuity?.anniversaryDate : ''
      )
      .pipe(
        finalize(() => {
          this.isAMPItemLoading = false
        }),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe({
        next: (model: AMPSubscriptionDetailsItemViewModel) => {
          this.activeTotal = '0';
          this.AMPDetailsItemViewModel = model;        
          this.ampSubs = this.AMPDetailsItemViewModel.subscriptions;
          this.adobeService.setCurrentAMPSubscriptions(this.ampSubs)
          this.ampSubs.forEach(sub => {
            this.activeTotal = (this.commonService.toNumber(this.activeTotal) + (this.showing(sub) ? this.commonService.toNumber(sub.out_amount) : 0)).toString();
          })
          this.ampSubsTableDataSource = new MatTableDataSource(this.ampSubs);
        },
        error: (err: string) => this.commonService.implementToast(err, "Error")
      });
  }

  private showAnniversaryDate(annuity: AnnuityViewModel): boolean {  
    const ToDate = new Date();
    const anniversaryDate = this.commonService.getDate(annuity?.anniversaryDate)
    return (new Date(anniversaryDate).getTime() >= ToDate.getTime())
  }

  public applySubListFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.ampSubsTableDataSource.filter = filterValue.trim().toLowerCase();
  }

  public applyOrderHistoryFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.orderHistoryTableDataSource.filter = filterValue.trim().toLowerCase();
  }

  public openGetOrderHistory() {
    if (!this.orderHistoryTabOpened) {
      this.orderHistoryTabOpened = true;
      this.loadOrderHistory();
    }
  }

  private loadOrderHistory() {
    this.orderHistoryLoading = true;
    const startDate = this.datePipe.transform(new Date(Date.now() - 30 * this.orderHistoryPage * 24 * 60 * 60 * 1000), 'yyyy-MM-dd');
    const endDate = this.orderHistoryPage > 1 ? this.datePipe.transform(new Date(Date.now() - 30 * (this.orderHistoryPage - 1) * 24 * 60 * 60 * 1000), 'yyyy-MM-dd') : '';
    const startDateDisplay = this.datePipe.transform(startDate, 'dd/MM/yyyy');
    this.orderHistoryDateFromText = ' FROM - ' + startDateDisplay
    this.adobeService.getAMPOrdersByCustomer(
      this.tenantId,
      '',
      startDate,
      endDate,
      true
    )
      .pipe(
        finalize(() => {
          this.orderHistoryLoading = false;
        }),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe({
        next: (res: IAMPOrdersByCustomerResponse[]) => {
          this.orderHistory = [ ...this.orderHistory, ...res ];
          this.orderHistoryTableDataSource = new MatTableDataSource(this.orderHistory);
          this.appplyOrderHistoryFilter();
        },
        error: (err: string) => this.commonService.implementToast(err, "Error")
      });
  }

  public orderHistoryLoadMore() {
    this.orderHistoryPage += 1;
    this.loadOrderHistory();
  }

  isDevOps() {
    return this.commonService.getIsDevOps();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  close() {
    this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/AMP');
    $('#levelOne').animate({ scrollLeft: 0 }, 400);
  }
  
  public manageAMPSubscription(subscription: GetAMPSubscription): void {
    this.adobeService.AMPSubscriptionSimpleView.next(subscription);
    const isScheduled = subscription?.out_status_desc == 'Scheduled';
    this.router.navigate([(isScheduled ? 'ManageSubscriotionScheduled/' : 'ManageSubscriotion/') + subscription?.out_subscription_id], { relativeTo: this.activatedRoute });
  }

  public goToAMPProductList(category: string): void {
    $('#levelOne').animate({ scrollLeft: $('#manageamp').width() + 505 }, 400);
    this.router.navigate(['AddAMPProducts/' + category], { relativeTo: this.activatedRoute });
  }

  public getRRPTotal(s: GetAMPSubscription): number {
    return this.commonService.toNumber(s?.out_rrp) * this.commonService.toNumber(s?.out_confirmed_qty);
  }

  public showing(sub: GetAMPSubscription): boolean {
    return sub ? ['Active', 'Scheduled'].includes(sub?.out_status_desc) : false;
  }

  public showRenewNow(): boolean {
    return this.ampSubs.some(s => (s?.out_status_desc == 'MANUAL_RENEWAL'));
  }

  public renewNow(): void {
    let AMPsubsItemsPendingList: IAMPAnnuityItemsViewModel[] = [];
    const confirmSubscriptions = [] as AMPubscriptionModel[];

    const inactives = this.ampSubs.filter(s => (s?.out_status_desc == 'MANUAL_RENEWAL'));

    const effectiveDate = this.details?.customer?.three_year_commitment_status.toLocaleLowerCase() == 'committed' ? this.datePipe.transform(this.details?.customer?.three_year_commitment_start_date, 'dd-MM-yyyy') : null;
    console.log(inactives);
    inactives.forEach(i => {

      const pedningItem = {
        programType: "AMP",
        lineSequence: "0",
        billingFrequency: i.out_billing_freq,
        billingFrequencyDesc: i.out_billing_freq_desc,
        isExisting: false,
        quantity: this._decimalPipe.transform(i.out_qty, '1.0-0'),
        stockCode: i.out_stock_code,
        description: i.out_stk_description,
        itemPrice: i.out_price,
        itemRRPrice: i.out_rrp,
        chargeType: i.out_charge_type,
        stockGroup: i.out_stock_group,
        offerId: i.out_offer_uri
      } as AnnuityItemsViewModel

      AMPsubsItemsPendingList.push(pedningItem)

      const previewItem = {
        tenantId: this.tenantId,
        mpnId: this.commonService.parseNPM(i.out_mpnid),
        subscriptionId: i.out_subscription_id,
        subscriptionDescription: i.out_sub_description,
        stockDescription: i.out_stk_description,
        parentSubscriptionId: '',
        stockCode: i.out_stock_code,
        qty: this._decimalPipe.transform(i.out_qty, '1.0-0')?.toString(),
        status: '',
        ownerEmail: i.out_default_email,
        price: i.out_price,
        totalPrice: i.out_amount,
        billingFrequency: i.out_billing_freq,
        stockGroup: i.out_stock_group,
        offerId: i.out_offer_uri,
        chargeType: i.out_charge_type,
        orderType: 'PREVIEW',
        inEffectivePriceDate: effectiveDate
      } as AMPubscriptionModel;
      
      confirmSubscriptions.push(previewItem);
    });

    this.loadingPreview = true
    this.adobeService.createOrCancelAMPSubscription(confirmSubscriptions)
      .pipe(
        finalize(() => {
          this.loadingPreview = false
        }),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe({
        next: (res: IAMPModifySubscriptionResponse[]) => {
          if (res.length) {
            let navigate = true;
            const allExistingSKU = [ ...this.ampSubs ]?.map(x=> x.out_stock_code);
            
            AMPsubsItemsPendingList = [ ...AMPsubsItemsPendingList ].map((item, index) => {
  
              item.isExisting = allExistingSKU.includes(item.stockCode);
              item.previewPrice = this.currencyPipe.transform(res[index].unitPrice,'AUD', 'symbol-narrow','.2-2');
              item.previewRRP = this.currencyPipe.transform(res[index].rrp, 'AUD', 'symbol-narrow','.2-2');
              item.previewStockCode = res[index].stockDescription;
              item.preivewDescription = res[index].subscriptionDescription;
              item.message = res[index].message;
    
              if (res[index].message != 'Successful' && navigate) {
                navigate = false;
                this.commonService.implementToast((res[index].message), "Error");
              }
    
              return item
            });

            const filteredList = AMPsubsItemsPendingList.filter(item => item.message !== 'Product not found');
            if (filteredList.length !== AMPsubsItemsPendingList.length) {
              this.commonService.implementToast("Product not found", "Error");
              AMPsubsItemsPendingList = filteredList;
            }
    
            if (navigate) {
              this.adobeService.monitorAMPPendingSubscriptions(AMPsubsItemsPendingList);
              this.router.navigate(['RenewAMPProducts'], { queryParamsHandling: 'preserve', relativeTo: this.activatedRoute });
            }
          }
        },
        error: (error: string) => this.commonService.implementToast(error, "Error")
      });
  }
  downloadRenewalPreview(action: string, event: Event, details: any): void {
    event.stopPropagation();
    this.previewRenewalSubs = [];   
    if (this.renewalPreview[1] === false) {
      this.commonService.implementToast(this.renewalPreview[0] as string, 'Error');
      return; 
    }    
    if (this.renewalPreview  !== undefined && this.renewalPreview.length > 0 ) {
      this.renewalPreview.forEach(res => {
        this.previewRenewalSubscription = {} as AMPubscriptionModel;       
        if(res.eligibilityCriteria){                 
          this.previewRenewalSubscription = {
            subscriptionId: res.subscriptionId,
            subscriptionDescription: res.stock_description,
            stockDescription: 'Eligible Offers',
            qty: res.eligibilityCriteria.minQuantity.toString(),
            proratedDays: '',
            unitCost_RRP: res.rrp,
            resellerBuy: res.reseller_buy,
            offerId: res.offerId,
            stockCode : res.offerId,
            price :  res.reseller_buy
          };
        }
       else{     
        this.previewRenewalSubscription = {
          subscriptionId: res.subscriptionId,
          subscriptionDescription: res.stock_description,
          //stockDescription: 'Line Items',
          qty: res.quantity.toString(),
          proratedDays: '',
          unitCost_RRP: res.rrp,
          resellerBuy: res.reseller_buy,
          offerId: res.offerId,
          stockCode : res.offerId,
          price :  res.reseller_buy     
        };
      }
        if (this.previewRenewalSubscription) {
          this.previewRenewalSubs.push(this.previewRenewalSubscription);
        }

      });    
      this.adobeService.downloadExcelAbobeConfirmProducts(this.previewRenewalSubs, action, details).subscribe((res: AMPubscriptionModel) => {
        //const fileName = `Renewal_Preview_Report`;
        var now = new Date();
        const dateTime = this.datePipe.transform(now, 'yyyy-MM-dd\'T\'HH:mm:ss');        
        const fileName = `Indicative Renewal_${dateTime}_${this.details.customer.company_name}.xlsx`;
        this.fileService.saveAsExcelFile(res, fileName);
        this.ngProgress.done();
        this.commonService.implementToast('Report downloaded successfully', 'Success');
      });
    }
    else{
      this.commonService.implementToast('No data to download', 'Error');
    }
    
  }

  public viewHighGrowthRenewals(): void {
    this.router.navigate(['ViewHighGrowthOffers'], { queryParamsHandling: 'preserve', relativeTo: this.activatedRoute });
  }
}